<p-dialog [(visible)]="authService.visible_login" class="d_overlaygrl">


    <form class="login100-form" autocomplete="off" [formGroup]="myForm" class="d_loginform" novalidate>

        <span class="d_titlegrloverlay">Ingresar</span>

        <div class="wrap-input100 m-b-23 d_dataforminput">
            <span class="label-input100">Usuario</span>
            <input class="input100" type="text" formControlName="email" placeholder="Correo electrónico">
            <span class="focus-input100"></span>
        </div>

        <div class="wrap-input100 d_dataforminput">
            <span class="label-input100">Contraseña</span>
            <p-password class="input100" formControlName="password" [feedback]="false" [toggleMask]="true" placeholder="Ingrese su contraseña"></p-password>
            <span class="focus-input100"></span>
        </div>

        <div class="text-right p-t-8 p-b-31"></div>


        <button class="d_buttongrl" (click)="login()" type="submit">
            <svg viewBox="0 0 70 70">
                <path d="M58.6,21.6c-6-9.7-17.1-14.5-28.1-12.2c-9.1,1.9-15.6,7.3-19.4,16.1c-0.3,0.7-0.3,1.4-0.1,2c0.2,0.6,0.7,1,1.3,1.2
                    c1.2,0.5,2.4-0.2,3-1.5c3.8-9.3,13-14.8,23-13.7C49.5,14.7,58,24.1,58,35.4c0,3.9-1,7.6-2.9,11c-3.3,5.8-8.9,9.7-15.5,10.8
                    c-6.6,1.1-13.2-0.7-18.2-5c-2.7-2.3-4.8-5.2-6.1-8.6c-0.5-1.2-1.8-1.8-2.9-1.4c-1.2,0.5-1.8,1.7-1.3,3c0.1,0.3,0.3,0.6,0.4,0.9
                    c4.2,9.1,11.4,14.4,21.2,15.8c1.2,0.2,2.4,0.2,3.6,0.2c5.4,0,10.5-1.7,15.2-5C62.7,49.2,65.9,33.3,58.6,21.6z"/>
                <path d="M38.2,37.7l-0.9,0.9c-1.6,1.6-3.2,3.1-4.7,4.7c-0.9,0.9-0.9,2.3-0.1,3.2c0.4,0.4,1,0.7,1.6,0.7c0,0,0,0,0,0
                    c0.6,0,1.2-0.2,1.6-0.7c3-2.9,6.1-6,9.5-9.5c0.9-0.9,0.9-2.3,0-3.2c-2.9-2.9-6.3-6.3-9.6-9.5c-0.5-0.5-1.3-0.6-1.9-0.6c0,0,0,0,0,0
                    c-0.9,0-1.6,0.6-1.8,1.5c-0.3,0.9-0.1,1.7,0.6,2.4c1.6,1.6,3.1,3.1,4.7,4.7l0.9,0.9H9.7l-0.2,0c-0.2,0-0.4,0-0.6,0
                    c-0.8,0.1-1.5,0.5-1.9,1.3c-0.4,0.7-0.3,1.6,0.2,2.2c0.6,0.9,1.5,1,2.2,1c0,0,0,0,0,0c7.7,0,15.4,0,23.1,0L38.2,37.7z"/>
            </svg>
            <p>Entrar</p>
        </button>

        <div class="flex-col-c p-t-60">
            <!-- <span class="txt1 p-b-17">
                ¿No tienes cuenta?
            </span> -->

            <!-- <a routerLink="/auth/register" class="txt2">
                Crear una aquí
            </a> -->

            <!-- <button class="d_buttongrltxt" (click)="loginInvitado()">Ingresar como invitado</button> -->

            <span class="txt1 p-b-17">
            </span>
        </div>
    </form>
</p-dialog>
